import script from "./DeletePost.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletePost.vue?vue&type=script&setup=true&lang=js"

import "./DeletePost.vue?vue&type=style&index=0&id=0f69a198&lang=scss"

const __exports__ = script;

export default __exports__